import type { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { Button } from '../../lib/ui/Button';
import type { Survey } from '../logic';

export const NextQuestionButton: FC<{ survey: Survey; className?: string | null }> = observer(({ survey, className }) => {
  const { currentQuestionModel } = survey;

  return (
    <Button
      text={currentQuestionModel.question.button_name || 'Далее'}
      onClick={() => void survey.goToNextQuestion()}
      className={className}
      isLoading={survey.sendingUserAnswer}
    />
  );
});
